import { Injectable } from '@angular/core';
import { CallMeBack } from '@shared/models/call-me-back';

import callMeBackMock from '@mocks/callMeBack.json';
import { Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CommonService } from './common.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CallmebackService {
  private callMeBackMock: CallMeBack;

  constructor(
    private commonService: CommonService,
    private http: HttpClient
  ) {
    this.callMeBackMock = callMeBackMock;
  }

  public postCallMeBack(callMeBack: CallMeBack): Observable<CallMeBack> {
    if (this.commonService.useMocks) {
      return new Observable(observer => observer.next(this.callMeBackMock));
    }

    return this.http.post<CallMeBack>(this.commonService.getServiceUrl('call-me-back'), callMeBack);
  }
}
